<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />
        <!-- 主體 -->
        <div class="mainContent">

            <!-- 農業情報站 -->
            <div>
                <!-- 農業氣象服務專區 -->
                <div :class="group_menu.agri.style" class="w3-container w3-padding-16" @click="goPwaWeatherStationAgri()">
                    <div class="w3-left"><i :class="group_menu.agri.icon" class="fa-solid w3-xxxlarge"></i></div>
                    <div class="w3-right">
                        <h3><i class="fa-solid fa-angle-right"></i></h3>
                    </div>
                    <div class="w3-clear"></div>
                    <h4>{{ group_menu.agri.title }}</h4>
                </div>
                <!-- 漁業氣象服務專區 -->
                <div :class="group_menu.fishery.style" class="w3-container w3-padding-16" @click="goPwaWeatherStationFishery()">
                    <div class="w3-left"><i :class="group_menu.fishery.icon" class="fa-solid w3-xxxlarge"></i></div>
                    <div class="w3-right">
                        <h3><i class="fa-solid fa-angle-right"></i></h3>
                    </div>
                    <div class="w3-clear"></div>
                    <h4>{{ group_menu.fishery.title }}</h4>
                </div>
                <!-- 氣象預報服務專區 -->
                <div :class="group_menu.sensing.style" class="w3-container w3-padding-16" @click="goPwaWeatherSensingList()">
                    <div class="w3-left"><i :class="group_menu.sensing.icon" class="fa-solid w3-xxxlarge"></i></div>
                    <div class="w3-right">
                        <h3><i class="fa-solid fa-angle-right"></i></h3>
                    </div>
                    <div class="w3-clear"></div>
                    <h4>{{ group_menu.sensing.title }}</h4>
                </div>
            </div>
 
        </div>
    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}                  
    },  
    components: {
        Header
    },
    data(){
        return {
            //標題
            title: "中央氣象觀測站",
            //群組(選單)
            group_menu:{
                title:"選單", 
                agri:{
                    style:"w3-teal",
                    title:"農業氣象服務專區",
                    icon:"fa-seedling"
                },
                fishery:{
                    style:"w3-blue",
                    title:"漁業氣象服務專區",
                    icon:"fa-fish"
                },
                sensing:{
                    style:"w3-red",
                    title:"氣象預報服務專區",
                    icon:"fa-cloud"
                },
            },
        }
    },
    methods: {
        //前往 首頁
        goHome:function(){ window.setPage("home"); },
        //前往 農業氣象服務專區
        goPwaWeatherStationAgri() { window.location = "pwa.html#/PwaWeatherStationAgri"; },
        //前往 漁業氣象服務專區
        goPwaWeatherStationFishery() { window.location = "pwa.html#/PwaWeatherStationFishery"; },
        //前往 氣象預報服務專區
        goPwaWeatherSensingList() { window.location = "pwa.html#/PwaWeatherSensingList"; },
    }
}
</script>